import React, { useState } from 'react';
import { Modal, Form, Input, Button, message } from 'antd';
import { MailOutlined, UserOutlined } from '@ant-design/icons';
import { sendMail } from '../../../services/Mail_service';

interface BillingEmailModalProps {
  visible: boolean;
  onCancel: () => void;
  onSuccess: () => Promise<void>;
  clientEmail: string;
  clientName: string;
  announcementDetails: {
    support?: string;
    amount: number;
    type: string;
    montantTTC?: number;
  };
  paymentLink: string;
}

export default function BillingEmailModal({
  visible,
  onCancel,
  onSuccess,
  clientEmail,
  clientName,
  announcementDetails,
  paymentLink,
}: BillingEmailModalProps) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

const defaultMessage = `
<p>Bonjour,</p>

<p>Votre conseil ${clientName} nous a transmis la demande de publication de votre annonce légale, réalisée en votre faveur.</p>

<p>Veuillez trouver ci-dessous les éléments relatifs à cette parution :</p>

<ul>
  <li><strong>Support de presse :</strong> ${announcementDetails.support || '------'}</li>
  <li><strong>Type d’annonce :</strong> ${announcementDetails.type || '--------'}</li>
  <li><strong>Montant à régler :</strong> ${announcementDetails.montantTTC ? announcementDetails.montantTTC.toFixed(2) + ' €' : '------- €'}</li>
  <li><strong>Lien de paiement :</strong> <a href="${paymentLink}">Cliquez ici</a></li>
</ul>

<p>Le règlement de cette somme permettra la validation immédiate de la publication et l’émission de l’attestation officielle de parution, destinée à vos conseils pour finalisation du dossier.</p>


<p>Nous vous remercions par avance pour votre réactivité et pour la confiance accordée à notre service.</p>

<p>Très cordialement,<br/>
L’équipe ALO<br/>
Annonce Légale Officielle – <a href="http://ALO-FR.fr">ALO-Annonce Légale Officielle vos annonces en quelques clics</a><br/>
(Support agréé pour la diffusion d’annonces légales et judiciaires)</p>
`;

  const handleSubmit = async (values: any) => {
  setLoading(true);
  try {
    const payload = {
      name: values.name || clientName,
      email: values.email || clientEmail,
      object: values.object || `Facturation de la création d'annonce - ${announcementDetails.type}`,
      sender: values.sender || undefined,
      message: values.message || defaultMessage,
      bcc: values.bcc || [],
      allowUnsubscribe: values.allowUnsubscribe || false,
    } as any;

    await onSuccess();
    message.success('Email de facturation envoyé avec succès !');
    form.resetFields();

  } catch (err: any) {
    console.error('Erreur envoi email :', err);
    message.error(err?.message || "Erreur lors de l'envoi de l'email");
  } finally {
    setLoading(false);
  }
};

  return (
<Modal
  title={
    <span style={{ color: "#4bb0c0",fontWeight: 'bold',fontSize: '18px' }}>
      Envoyer la facturation au client
    </span>
  }
  open={visible}
  onCancel={onCancel}
  footer={null}
  width={700}
>

      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{
          email: clientEmail,
          object: `Facturation de la création d'annonce - ${announcementDetails.type}`,
          message: defaultMessage,
          name: clientName,
        }}
      >
        <Form.Item
          label="Email du client"
          name="email"
          rules={[
            { required: true, message: "L'email est requis" },
            { type: 'email', message: 'Email invalide' },
          ]}
        >
          <Input prefix={<MailOutlined />}
            placeholder="Email du client"
            defaultValue={clientEmail} />
        </Form.Item>

        <Form.Item label="Nom du client" name="name">
          <Input prefix={<UserOutlined />} disabled />
        </Form.Item>

        <Form.Item
          label="Objet de l'email"
          name="object"
          rules={[{ required: true, message: "L'objet est requis" }]}
        >
          <Input placeholder="Objet de l'email" />
        </Form.Item>

        {/* <Form.Item
          label="Message"
          name="message"
          rules={[{ required: true, message: 'Le message est requis' }]}
        >
          <Input.TextArea rows={10} placeholder="Votre message..." />
        </Form.Item> */}

        <Form.Item className="mb-0">
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
            <Button onClick={onCancel}>Annuler</Button>
            <Button
              htmlType="submit"
              loading={loading}
              style={{ backgroundColor: '#2A919D' ,color:'white'}}
            >
              <span style={{color:"white"}}>Envoyer la facturation</span>
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}
